import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchIdentity } from '@office-start/identity-service';
import { setUserStorageItem, } from '@office-start/user-storage-service';
import { setUserItem as setLocalStorageUserItem } from '@office-start/web-storage-utility';
import { getLocalStorageKey } from '../helpers/getLocalStorageKey';
export function updateNewUserState(storageKey, state) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, officeComponentContext, identity, options;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        fetchOfficeComponentContext(),
                        fetchIdentity(),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), officeComponentContext = _a[0], identity = _a[1];
                    options = {
                        correlationId: officeComponentContext.correlationId,
                        getAccessToken: officeComponentContext.getAccessToken,
                        getIdentity: function () { return Promise.resolve(identity); },
                        inMockMode: officeComponentContext.inMockMode,
                        jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
                        officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
                        workload: officeComponentContext.workload,
                    };
                    setLocalStorageUserItem(identity.puid, getLocalStorageKey(storageKey), state);
                    setUserStorageItem(storageKey, state, options);
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=updateNewUserState.js.map